import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import './Skeleton.scss';
var Skeleton = function Skeleton(props) {
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "skeleton"
  }, props));
};
export default Skeleton;